import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/helpers/loading'

export default {
  setOpeningHours({ commit }, openingHours) {
    commit(types.SET_OPENING_HOURS, openingHours)
  },
  setIsOpen({ commit }, isOpen) {
    commit(types.SET_ISSHOPOPEN, isOpen)
  },
  async isShopOpen({ dispatch, rootGetters }, data) {
    const userProfile = rootGetters['auth/userProfile']
    // Calculate the CurrentDate / CurrentTime here so that it accurately reflects the time the user is seeing
    const now = new Date()
    const currentDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
    const currentTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`
    const r = await startLoading(dispatch, 'isShopOpen', () =>
      http.get(`openingHours/isShopOpen?currentDate=${currentDate}&currentTime=${currentTime}&customer=${userProfile.location?.name}&timezone=${userProfile.timeZone}&loggedInUser=${userProfile.userName}&userEmail=${userProfile.email}&tenantId=${data}`)
    )
    const respObj = JSON.parse(r.data)
    if (!respObj) {
      return false
    }

    await dispatch('setIsOpen', respObj.IsOpen)
    if (!respObj.IsOpen) {
      await dispatch('setOpeningHours', respObj.OpeningHoursJson)
    }
    return respObj.IsOpen
  },
  async getTenantDetails({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getTenantDetails', () =>
      http.get('openingHours/TenantDetails')
    )
    commit(types.SET_TENANT_DETAILS, r.data)
  }
}
